import { languageMapper } from "@smb/web-telemetry";

export const getBrowserLocale = (): string => {
  let language;
  // Firefox and Chrome.
  if (window.navigator.languages) {
    language = window.navigator.languages[0];
  } else {
    language = window.navigator.language;
  }

  return languageMapper(language);
};
